import React, { useContext } from 'react';
import styled from '@emotion/styled';
import ReactLib from '@owenscorning/react-library'

const { Connect: { FormElements: { Form } } } = ReactLib

const NextButton = styled.button`
  background-color: #D40F7D;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 18px;
  margin-top: 1.5rem;
  padding: .5rem;
  width: 100%;

  :disabled {
    background-color: #D8D8D8;
    cursor: default;
  }
`;

export default (props) => {
  const { submitEnabled } = useContext(Form.Context);
  return <NextButton disabled={!submitEnabled} {...props}>Next</NextButton>
}
